import styled from 'styled-components'

export const ButtonWrapper = styled.label`
	cursor: pointer;

	.button-hidden-input {
		display: none;
	}
`
